import Averages from '../averages'

const InformationContent = (): JSX.Element => {
  return (
    <div className="px-4">
      <div className="flex w-full flex-col py-4">
        <Averages />
      </div>
    </div>
  )
}

export default InformationContent
